import { Component, OnInit, Input, ViewChild} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-select-field',
  templateUrl: './select-field.component.html',
  styleUrls: ['./select-field.component.css']
})
export class SelectFieldComponent implements OnInit {
  @Input() field: any;
  @ViewChild('invalidTooltip') invalidTooltip:NgbTooltip;
  fCtrl:FormControl;
  constructor() {

  }
  ngOnInit() {
    // console.log(this.field);
    if (this.field.bepoz_field_name == 'Title') {
      this.field.multi_values = [
        { "text": "Mr" },
        { "text": "Mrs" },
        { "text": "Ms" },
        { "text": "Miss" },
        { "text": "Master" }
      ]
    }

    if (this.field.bepoz_field_name == 'Gender') {
      this.field.multi_values = [
        { "text": "Male" },
        { "text": "Female" },
        { "text": "Other" },
      ]
    }

    if (this.field.bepoz_field_name == 'State') {
      this.field.multi_values = [
        { "text": "ACT" },
        { "text": "NSW" },
        { "text": "QLD" },
        { "text": "SA" },
        { "text": "TAS" },
        { "text": "VIC" },
        { "text": "WA" },
      ]
    }

    if(this.field.required){
      this.fCtrl = new FormControl('',Validators.required);
    }else{
      this.fCtrl = new FormControl('');
    }

    //listening input state changes
    this.fCtrl.statusChanges.subscribe(status => {
      // console.log(status);
      if(status == 'INVALID' && (this.fCtrl.dirty || this.fCtrl.touched)){
        this.invalidTooltip.open();
      }
      if(status == 'VALID'){
        this.invalidTooltip.close();
      }
    });

    //pass formcontrol to field obj
    this.field.formControl = this.fCtrl;
    this.field.invalidTooltip = this.invalidTooltip;
  }

  //when focus:blur check input status
  onFocusOutCheck(event){
    if(this.fCtrl.invalid){
      this.invalidTooltip.open();
    }
  }

}
